export default {
      id: "ic-canli-izle-usage",
      viewBox: "0 0 48 48",
      url: "/" + "images/icons.3.109.2.svg#ic-canli-izle-usage",
      toString: function () {
        return this.url;
      }
    }